import { render, staticRenderFns } from "./UGSAdsRemoteConfig.vue?vue&type=template&id=ba8934be&"
import script from "./UGSAdsRemoteConfig.vue?vue&type=script&lang=js&"
export * from "./UGSAdsRemoteConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports